import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time1",
  "use": "icon-time1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-time1\"><path d=\"M120.512 512a391.488 391.488 0 1 1 782.976 0A391.488 391.488 0 0 1 120.512 512zM512 50.112a461.888 461.888 0 1 0 0 923.776A461.888 461.888 0 0 0 512 50.112zM547.2 256a35.2 35.2 0 1 0-70.4 0v256a35.2 35.2 0 0 0 19.456 31.488l170.688 85.312a35.2 35.2 0 1 0 31.488-62.976L547.2 490.304V256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol